//                                                           //
//  Program: PayoutsReports.jsx                              //
//  Application: Report                                      //
//  Option: Property Reports Listing                         //
//  Developer: NP 		                                     //
//  Date: 2022-08-30                                         //
//                                                           //
/////////////////////////////////////////////////////////   ///

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Tab, Modal, InputGroup, Form } from "react-bootstrap";
import ReportSidebar from "../common/ReportSidebar";
import SimpleReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import ReportService from "../../services/ReportService";
import ffeBalanceCell from "./ffeBalanceCell";
import Select from "react-select";
import UnitsService from "../../services/UnitsService";
import Moment from "moment";
import MultiImageService from "./../../services/MultiImageService";
import AllPropertyReportSidebar from "../common/AllPropertyReportSidebar";
import ChannelService from "../../services/ChannelService";
import PropertyService from "../../services/PropertyService";
import Vars from "../../Vars";
import {
  saveReportFilter,
  loadReportFilter,
  clearReportFilter,
  buildRestoredFilterState,
  buildDefaultCheckoutDateQuery,
} from "../../utils/reportSharedFilter";

class PayoutsReports extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.checkoutDateFromInputGroupRef = React.createRef();
    this.checkoutDateToInputGroupRef = React.createRef();
    this.reservation_status = Vars?.reservationStatusList;
    this.state = {
      checkoutDateFromPlacement: "bottom-start",
      checkoutDateToPlacement: "bottom-start",
      errors: {},
      importModal: false,
      file_url: "",
      file_name: "",
      open: true,
      eventKey: "0",
      is_inactive: false,
      isSubmit: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      module_search: "",
      module_search_display: "",
      exportMesssage: "",
      exportFilePath: "",
      exportResult: "",
      alertType: "xlsx",
      is_search: 0,
      isSearch: global.isSearch,
      is_pay_out_modal: false,
      input: {},
      unitList: [],
      selectedUnitList: [],
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      filter_value: "",
      loading: false,
      showSpinner: false,
      total_record: 0,
      totalPayOutList: {},
      deleteRoleModal: false,
      property_slug: this.props.match.params.propertySlug,
      pathname: window.location.pathname,
      property_logo_url: sessionStorage.getItem("property_logo_url"),
      property_type: sessionStorage.getItem("property_type"),
      property_name: sessionStorage.getItem("property_name"),
      year_value: sessionStorage.getItem("year_value")
        ? sessionStorage.getItem("year_value")
        : "",
      records: [],
      newChannelList: [],
      selectChannelList: [],
      selectedChannelList: [],
      config: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: false,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      configPay: {
        sort: {
          column: "",
          order: "",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: false,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No data found",
        },
      },
      newPropertyList: [],
      selectedPropertyList: [],
      modal_property_slugs: [],
      modal_property_labels: [],
      newUnitList: [],
      extraButtons: [],
      columns: [
        {
          key: "unit_number",
          text: "Unit",
          className: "unit_number hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            if (record.is_fut_title) {
              return record.aka_name + " " + record.unit_number;
            } else if (record.unit_number) {
              return record.unit_number;
            } else {
              return "";
            }
          },
        },
        {
          key: "resident_name",
          text: "Resident Name",
          className: "hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.resident_name;
          },
        },
        {
          key: "payout_recipient",
          text: "Payout Recipient",
          className: "hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.w9_resident_name;
          },
        },
        {
          key: "channel_name",
          text: "Channel",
          className: "channel_name hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.channel_name;
          },
        },
        {
          key: "confirmation_code",
          text: "Reservation Code",
          className: "confirmation_code hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            if (
              record.confirmation_code === "Long Term" ||
              record.is_long_term
            ) {
              return "Long Term";
            }
            return record.reservation_slug ? record.reservation_slug : "";
          },
        },
        {
          key: "Check In Date",
          text: "Check In",
          className: "checkin_date hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.checkin_date;
          },
        },
        {
          key: "Check Out Date",
          text: "Check Out",
          className: "checkout_date hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            if (
              ["Total", "Date Range Grand Total"].includes(record.checkout_date)
            ) {
              return (
                <span
                  id="to-pay"
                  className={
                    (record.checkout_date === "Date Range Grand Total"
                      ? "grand_total1"
                      : "to-pay1") + " resident-to"
                  }
                >
                  {record.checkout_date}
                </span>
              );
            } else if (record.checkout_date == "Future Grand Total") {
              return <span className="future-grand1">Future Grand Total</span>;
            } else if (record.checkout_date == "Past Grand Total") {
              return <span className="past-grand1">Past Grand Total</span>;
            } else if (record.is_fut_title) {
              return <span className="future-row1"></span>;
            } else if (record.is_different) {
              return <span className="diff-line1"></span>;
            } else {
              return record.checkout_date;
            }
          },
        },
        {
          key: "Nights Booked",
          text: "No of Nights Booked",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.total_stay_nights;
          },
        },
        {
          key: "gross_revenue",
          text: "Gross Revenue",
          className: "gross_revenue hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.gross_revenue;
          },
        },
        {
          key: "long_term_revenue",
          text: "Long-Term Revenue",
          className: "long_term_revenue hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.long_term_revenue;
          },
        },
        {
          key: "nightly_revenue",
          text: "Guest Paid Nightly Revenue",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.total_nightly_rate;
          },
        },
        {
          key: "voucher_discount",
          text: "Voucher Discount",
          className: "voucher_discount hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.voucher_discount;
          },
        },
        {
          key: "per_total_nightly",
          text: "Property Payout (%) Guest Paid Nightly Revenue",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.nightly_per;
          },
        },
        {
          key: "per_total_nightly",
          text: "Property Payout ($) Guest Paid Nightly Revenue",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.nightly_per_amount;
          },
        },
        // {
        //   key: "creditor",
        //   text: "Creditor",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.creditor;
        //   },
        // },
        // {
        //   key: "wh_start_date",
        //   text: "FF&E Brokerage Fee Start Date",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.wh_start_date;
        //   },
        // },
        // {
        //   key: "wh_end_date",
        //   text: "FF&E Brokerage Fee End Date",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.wh_end_date;
        //   },
        // },
        // {
        //   key: "wh_percentage",
        //   text: "FF&E Brokerage Fee %",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.wh_percentage;
        //   },
        // },
        // {
        //   key: "wh_earning_period",
        //   text: "FF&E Brokerage Fee (Reporting Period)",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.wh_earning_period;
        //   },
        // },
        // {
        //   key: "intro_start_date",
        //   text: "Introductory Brokerage Fee Start Date",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.intro_start_date;
        //   },
        // },
        // {
        //   key: "intro_end_date",
        //   text: "Introductory Brokerage Fee End Date",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.intro_end_date;
        //   },
        // },
        // {
        //   key: "intro_percentage",
        //   text: "Introductory Brokerage Fee %",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.intro_percentage;
        //   },
        // },
        // {
        //   key: "intro_earning_period",
        //   text: "Introductory Brokerage Fee (Reporting Period)",
        //   className: "cleaning_fee hand-cursor text-center td_clickable",
        //   width: 300,
        //   cell: (record) => {
        //     return record.intro_earning_period;
        //   },
        // },
        {
          key: "ffe_basis",
          text: "FF&E Basis",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.ffe_basis;
          },
        },
        {
          key: "ffe_paid_down",
          text: "FF&E Paid Down ITD",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.ffe_paid_down;
          },
        },
        {
          key: "ffe_paid_down_period",
          text: "FF&E Paid Down (Reporting Period)",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.ffe_paid_down_period;
          },
        },
        {
          key: "ffe_balance_remaining",
          text: "FF&E Balance Remaining ITD",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return ffeBalanceCell(record.ffe_balance_remaining);
          },
        },
        {
          key: "ffe_percent_recouped",
          text: "FF&E % Recouped",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.ffe_percent_recouped;
          },
        },
        {
          key: "property_payout_percent",
          text: "Property Payout %",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.property_payout_percent;
          },
        },
        {
          key: "Cleaning Fee",
          text: "Guest Paid Cleaning Fee",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.cleaning_fee;
          },
        },
        {
          key: "per_cleaning",
          text: "Property Payout (%) Guest Paid Cleaning Fee",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.cleaning_per;
          },
        },
        {
          key: "per_cleaning",
          text: "Property Payout ($) Guest Paid Cleaning Fee",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.cleaning_per_amount;
          },
        },
        {
          key: "Channel Service Fee",
          text: "Channel Service Fee",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.host_service_fee;
          },
        },
        {
          key: "per_total_channel_service",
          text: "Property Responsible (%) for Channel Service Fee",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.channel_per;
          },
        },
        {
          key: "per_total_channel_service",
          text: "Property Responsible ($) for Channel Service Fee",
          className: "total_stay_nights hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.channel_per_amount;
          },
        },
        {
          key: "resolution_fees",
          text: "Resolution Fee (Property $)",
          className: "adr cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.to_building_total;
          },
        },
        {
          key: "parking_fee",
          text: "Parking Fee",
          className: "adr parking_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.parking_fee;
          },
        },
        {
          key: "property_payout",
          text: "Property Payout",
          className: "adr cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            return record.total_property_earning;
          },
        },
        {
          key: "status_id",
          text: "Reservation Status",
          className: "cleaning_fee hand-cursor text-center td_clickable",
          width: 300,
          cell: (record) => {
            const statusObj = this?.reservation_status?.find(
              (obj) => obj?.value == record?.status_id,
            );
            if (!statusObj) return "";
            return (
              <span className={statusObj?.value == "2" ? "text-danger" : ""}>
                {statusObj?.label}
              </span>
            );
          },
        },
      ],
      columns_pay: [
        /* {
          key: "Resident Name",
          text: "Resident Name",
          className: "reseident_name hand-cursor text-left td_clickable",
          width: 300,
          cell: (record_pay) => {
            return record_pay.resident_name ? record_pay.resident_name : "";
          },
        }, */
        /* {
          key: "Check In Date",
          text: "Check In Date",
          className: "checkin_date hand-cursor text-left td_clickable",
          width: 300,
          cell: (record_pay) => {
            return record_pay.checkin_date ? record_pay.checkin_date : "";
          },
        }, */
        /* {
          key: "Check Out Date",
          text: "Check Out Date",
          className: "checkout_date hand-cursor text-left td_clickable",
          width: 300,
          cell: (record_pay) => {
            return record_pay.checkout_date ? record_pay.checkout_date : "";
          },
        }, */
        /* {
          key: "Nights Booked",
          text: "Nights Booked",
          className: "total_stay_nights hand-cursor text-left td_clickable",
          width: 300,
          cell: (record_pay) => {
            return record_pay.total_stay_nights ? record_pay.total_stay_nights : "";
          },
        }, */
        /* {
          key: "Resident Payout",
          text: "Resident Payout",
          className: "resident_payout hand-cursor text-right td_clickable",
          width: 300,
          cell: (record_pay) => {
            return record_pay.resident_earning ? "$" + record_pay.resident_earning : "";
          },
        }, */
      ],
    };
    this.changeHandler = this.changeHandler.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.removeTotalClass = this.removeTotalClass.bind(this);
  }

  componentDidMount() {
    this._restoredFilter = this._loadSharedFilter();
    // Default the checkout-date filter to the current month on both the
    // global page and the property-level page — previously this only ran
    // when a propertySlug route param existed, so the global page's
    // "Search Applied On" display fell back to today's date instead.
    this.gerDefaultInOutDate();
    this.getPropertyData();
    if (this.props.match.params.propertySlug !== undefined) {
      this.getPayOutReports(
        this._restoredFilter ? this._restoredFilter.customQueryString : "",
      );
    }
  }

  _loadSharedFilter() {
    return loadReportFilter();
  }

  async getChannelList() {
    this.setState({ showSpinner: true, loading: true });
    var selectChannelList = [];
    var selectChannelListTotal = 0;

    let res = await ChannelService.getChannel("is_dropdown=1");
    if (global.successStatus.includes(res.status)) {
      selectChannelList = res.data ? res.data : [];
      selectChannelListTotal = selectChannelList ? selectChannelList.length : 0;
    }
    const newChannelList =
      selectChannelListTotal > 0
        ? selectChannelList.map(({ slug, channel_name }) => ({
            value: slug,
            label: channel_name,
          }))
        : [
            { value: "1", label: "Property Website" },
            { value: "2", label: "Airbnb" },
            { value: "3", label: "OTA" },
          ];
    this.setState({
      selectChannelList: selectChannelList,
      selectChannelListTotal: selectChannelListTotal,
      newChannelList: newChannelList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  async clearFilter() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.setState({ is_search: 0 });
    // Clear resets the date/unit/channel filters only — it must not touch
    // the Property dropdown selection (selectedPropertyList/modal_property_slugs)
    // or the persisted localStorage selection.
    this.setState({
      checkout_date_from: firstDay,
      checkout_date_to: lastDay,
      unit_slug: "",
      selectedUnitList: [],
      set_channel: "",
      selectedChannelList: [],
      unit_lable: "",
    });
    this.setState({ module_search: "" });
    clearReportFilter();
    this._restoredFilter = null;
    await this.removeTotalClass();
    this.getPayOutReports();
  }

  async ExportData() {
    this.setState({ showSpinner: true, isSubmit: true });
    // Route's own property_slug wins on a property-level page; otherwise fall back
    // to the global multi-select dropdown — same guard as getPayOutReports(), so
    // export always matches whatever the on-screen report is scoped to.
    const _activePropertySlug =
      this.props.match.params.propertySlug !== undefined
        ? this.state.property_slug
          ? this.state.property_slug
          : ""
        : this.state.modal_property_slugs &&
            this.state.modal_property_slugs.length > 0
          ? this.state.modal_property_slugs.join(",")
          : "";
    let data = {
      property_slug: _activePropertySlug,
    };

    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let unit_search = this.state.unit_slug
      ? this.state.unit_slug.map((slug) => `${slug}`).join(",")
      : "";
    let queryString =
      "property_slug=" +
      _activePropertySlug +
      "&is_export=1" +
      "&file_type=" +
      this.state.alertType +
      "&checkout_date_from=" +
      checkOutFromDate +
      "&unit_slug=" +
      unit_search +
      "&channel_slug=" +
      (this.state.set_channel ? this.state.set_channel : "") +
      "&checkout_date_to=" +
      checkOutDateTo;

    let res = await ReportService.exportPropertyPayOutReport(queryString);
    if (res.data.filePath) {
      this.getDownloadFile(res.data.filePath, res.data.fileName);
      this.setState({ exportMesssage: res.message });
      this.setState({ exportResult: data });
      this.setState({ exportFilePath: res.data.filePath });
    }
    this.setState({ showSpinner: false, isSubmit: false });
  }

  async getDownloadFile(url, name) {
    let file_name = name.split(".")[0];
    var queryString = "path=" + url + "&display_file_name=" + file_name;
    this.setState({ showSpinner: true, loading: true });
    let inputData = {
      // path: url,
    };
    var resData = {};
    await MultiImageService.downloadFile(inputData, queryString);
    this.setState(resData);
    this.setState({
      showSpinner: false,
      loading: false,
    });
  }

  exportToggle = () => {
    if (this.state.isModel === 1) {
      this.setState({ exportMesssage: "" });
      this.setState({ isModel: 0 });
      this.setState({ showSpinner: false, isSubmit: false });
    } else {
      this.setState({ isModel: 1 });
    }
  };

  gerDefaultInOutDate() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const stateUpdate = buildRestoredFilterState(
      this._restoredFilter,
      firstDay,
      lastDay,
    );
    if (stateUpdate) {
      this.setState(stateUpdate);
      return;
    }
    this.setState({ checkout_date_from: firstDay, checkout_date_to: lastDay });
  }

  changeExport(evt) {
    let value = evt.target.value;
    this.setState({ alertType: value });
  }

  async showPayoutReport(unitSlug) {
    this.setState({ showSpinner: true, loading: true });
    var listPay = [];
    var totalRecordsPay = 0;
    let payoutDetailsTitle;
    let data = {
      property_slug: this.state.property_slug,
    };
    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let queryString =
      "unit_slug=" +
      unitSlug +
      "&checkout_date_from=" +
      checkOutFromDate +
      "&checkout_date_to=" +
      checkOutDateTo;
    let res = await ReportService.showPayOutReport(data, queryString);
    if (global.successStatus.includes(res.status)) {
      listPay = res.data.data ? res.data.data : [];
      totalRecordsPay = res.data.data.length ? res.data.data.length : 0;
      payoutDetailsTitle = res.data.data.length
        ? res.data.data[0].aka_name + "-" + res.data.data[0].unit_number
        : "Pay Out Report";
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record_pay: totalRecordsPay,
      record_pay: listPay,
      payoutDetailsTitle: payoutDetailsTitle,
    });
    this.payoutDataModalToggle();
  }

  payoutDataModalToggle = () => {
    if (this.state.is_pay_out_modal === 1) {
      this.setState({ is_pay_out_modal: 0 });
    } else {
      this.setState({ is_pay_out_modal: 1 });
    }
  };

  getPayOutReports = async (queryString = "") => {
    this.removeTotalClass();
    this.setState({ showSpinner: true, loading: true });
    var list = [];
    var totalRecords = 0;
    const _activePropertySlug =
      this.props.match.params.propertySlug !== undefined
        ? this.state.property_slug
          ? this.state.property_slug
          : ""
        : this.state.modal_property_slugs &&
            this.state.modal_property_slugs.length > 0
          ? this.state.modal_property_slugs.join(",")
          : "";

    if (!queryString) {
      queryString = buildDefaultCheckoutDateQuery(
        this.state.checkout_date_from,
        this.state.checkout_date_to,
      );
    }

    let res = await ReportService.getPropertyPayOutReports(
      "property_slug=" +
        _activePropertySlug +
        (queryString ? "&" + queryString : ""),
    );
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data.data : [];
      totalRecords = res.data ? res.data.data.length : 0;
      if (list) {
        const filtered = list.filter((report) => {
          return report.is_different === undefined;
        });
        totalRecords = filtered ? filtered.length : 0;
      }
    }
    this.setState({
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
      records: list,
    });
    this.addTotalClass();
  };

  /** Add Class on page load */
  addTotalClass = () => {
    const child = document.getElementsByClassName("to-pay1");
    let childNo = child.length;
    for (let i = 0; i < childNo; i++) {
      let ele = child[i].parentElement.parentElement;
      ele.classList.add("to_total");
    }
    const childDiff = document.getElementsByClassName("diff-line1");
    let childNoDiff = childDiff.length;
    for (let i = 0; i < childNoDiff; i++) {
      let ele = childDiff[i].parentElement.parentElement;
      if (ele) {
        ele.classList.add("to_diff");
      }
    }
    const childFut = document.getElementsByClassName("future-row1");
    let childNoFut = childFut.length;
    for (let i = 0; i < childNoFut; i++) {
      let ele = childFut[i].parentElement.parentElement;
      if (ele) {
        ele.classList.add("to_future");
      }
    }
    if (document.getElementsByClassName("grand_total1").length > 0) {
      const grand_total = document.getElementsByClassName("grand_total1")[0];
      let ele1 = grand_total.parentElement.parentElement;
      ele1.classList.add("grand_total");
    }
    if (document.getElementsByClassName("future-grand1").length > 0) {
      const grand_total_fu =
        document.getElementsByClassName("future-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.add("grand_total_future");
    }
    if (document.getElementsByClassName("past-grand1").length > 0) {
      const grand_total_fu = document.getElementsByClassName("past-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.add("grand_total_past");
    }
  };

  removeTotalClass = async () => {
    const child = document.getElementsByClassName("to-pay1");
    let childNo = child.length;
    for (let i = 0; i < childNo; i++) {
      let ele = child[i].parentElement.parentElement;
      ele.classList.remove("to_total");
    }
    const childFut = document.getElementsByClassName("future-row1");
    let childNoFut = childFut.length;
    for (let i = 0; i < childNoFut; i++) {
      let ele = childFut[i].parentElement.parentElement;
      if (ele) {
        ele.classList.remove("to_future");
      }
    }
    const childDiff = document.getElementsByClassName("diff-line1");
    let childNoDiff = childDiff.length;
    for (let i = 0; i < childNoDiff; i++) {
      let ele = childDiff[i].parentElement.parentElement;
      if (ele) {
        ele.classList.remove("to_diff");
      }
    }
    if (document.getElementsByClassName("grand_total1").length > 0) {
      const grand_total = document.getElementsByClassName("grand_total1")[0];
      let ele1 = grand_total.parentElement.parentElement;
      ele1.classList.remove("grand_total");
    }
    if (document.getElementsByClassName("future-grand1").length > 0) {
      const grand_total_fu =
        document.getElementsByClassName("future-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.remove("grand_total_future");
    }
    if (document.getElementsByClassName("past-grand1").length > 0) {
      const grand_total_fu = document.getElementsByClassName("past-grand1")[0];
      let ele2 = grand_total_fu.parentElement.parentElement;
      ele2.classList.remove("grand_total_past");
    }
  };

  getPropertyData = async () => {
    let res = await PropertyService.getPropertyList("is_global_dropdown=1");
    let mapped = [];
    let newPropertyList = [{ value: "", label: "All Properties" }];
    if (global.successStatus.includes(res.status)) {
      const list = res.data ? res.data : [];
      mapped = list.map(({ slug, property_name }) => ({
        value: slug,
        label: property_name,
      }));
      newPropertyList = [{ value: "", label: "All Properties" }, ...mapped];
    }
    // Restore persisted multi-selection from previous report navigation.
    // Fall back to the single slug saved by listing-module OutSidePropertySelectBox.
    // Only applies on the global (no propertySlug route param) report page —
    // property-level pages must always start with an empty selection so the
    // route's own property_slug is used, not a stale global selection.
    let preSelectedSlugs = [];
    if (this.props.match.params.propertySlug === undefined) {
      try {
        const saved = localStorage.getItem("reportSelectedPropertySlugs");
        if (saved) preSelectedSlugs = JSON.parse(saved);
      } catch (e) {
        /* ignore malformed localStorage value */
      }
      if (!preSelectedSlugs.length) {
        const single = localStorage.getItem("outSidePorpertySlug");
        if (single) preSelectedSlugs = [single];
      }
    }
    const resolvedSelection = preSelectedSlugs.map(
      (slug) =>
        mapped.find((p) => p.value === slug) || { value: slug, label: slug },
    );
    // No saved selection — default to the "All Properties" chip, matching OutSidePropertySelectBox's default.
    const selectedPropertyList = resolvedSelection.length
      ? resolvedSelection
      : [{ value: "", label: "All Properties" }];
    const modal_property_slugs = selectedPropertyList
      .filter((p) => p.value)
      .map((p) => p.value);
    this.setState(
      { newPropertyList, selectedPropertyList, modal_property_slugs },
      () => {
        if (this.props.match.params.propertySlug === undefined) {
          this.getUnitData();
          this.getPayOutReports(
            this._restoredFilter ? this._restoredFilter.customQueryString : "",
          );
        }
      },
    );
  };

  /* to get unit data list */
  async getUnitData(queryString = "") {
    this.setState({ showSpinner: true, loading: true });
    var unitList = [];
    var unitListTotal = 0;
    const propertySlugParam =
      this.props.match.params.propertySlug !== undefined
        ? this.state.property_slug
          ? this.state.property_slug
          : ""
        : this.state.modal_property_slugs &&
            this.state.modal_property_slugs.length > 0
          ? this.state.modal_property_slugs.join(",")
          : "";
    let res = await UnitsService.getUnitsList(
      "is_dropdown=1&property_slug=" + propertySlugParam,
      queryString ? "&" + queryString : "",
    );
    if (global.successStatus.includes(res.status)) {
      unitList = res.data ? res.data : [];
      unitListTotal = unitList ? unitList.length : 0;
    }
    const newUnitList =
      unitListTotal > 0
        ? unitList.map(({ slug, unit_name, tower, total_tower_count }) => ({
            value: slug,
            label: unit_name,
          }))
        : [];
    this.setState({
      unitList: unitList,
      unitListTotal: unitListTotal,
      newUnitList: newUnitList,
    });
    this.setState({ showSpinner: false, loading: false });
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
    }
  };

  searchToggle = () => {
    if (this.state.isSearch === 1) {
      this.setState({ isSearch: 0 });
    } else {
      this.getUnitData();
      this.getChannelList();
      this.setState({ isSearch: 1 });
    }
  };

  handleChangeUnitList(value) {
    let unit_slug = [];
    let unit_lable = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        unit_slug.push(item.value);
        unit_lable.push(item.label);
      });
    }
    this.setState({
      selectedUnitList: value,
      unit_slug: unit_slug,
      unit_lable: unit_lable,
    });
    this.setState({ confirm_back: 1 });
  }

  handleChangePropertyList = (value) => {
    const values = value || [];
    const specificSelections = values.filter((v) => v.value !== "");
    // "All Properties" chosen, or every chip cleared — default back to the "All Properties" chip
    if (specificSelections.length === 0) {
      localStorage.removeItem("reportSelectedPropertySlugs");
      this.setState(
        {
          selectedPropertyList: [{ value: "", label: "All Properties" }],
          modal_property_slugs: [],
          modal_property_labels: [],
          selectedUnitList: [],
          unit_slug: "",
          unit_lable: "",
        },
        () => {
          this.getUnitData();
          this.getPayOutReports();
        },
      );
      return;
    }
    let slugs = specificSelections.map((item) => item.value);
    let labels = specificSelections.map((item) => item.label);
    localStorage.setItem("reportSelectedPropertySlugs", JSON.stringify(slugs));
    this.setState(
      {
        selectedPropertyList: specificSelections,
        modal_property_slugs: slugs,
        modal_property_labels: labels,
        selectedUnitList: [],
        unit_slug: "",
        unit_lable: "",
      },
      () => {
        this.getUnitData();
        this.getPayOutReports();
      },
    );
  };

  handleChangeChannel(value) {
    let set_channel = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        set_channel.push(item.value);
      });
    }
    const set_channel_value = value !== null ? value.value : [];
    this.setState({
      selectedChannelList: value,
      set_channel: set_channel_value,
    });
    this.setState({ confirm_back: 1 });
  }

  customValidate() {
    let isValid = true;
    return isValid;
  }

  getResponsivePlacement = (ref) => {
    if (!ref.current) return "bottom-start";

    const rect = ref.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const CALENDAR_HEIGHT_ESTIMATE = 330;
    const CALENDAR_WIDTH_ESTIMATE = 300;

    if (spaceBelow >= CALENDAR_HEIGHT_ESTIMATE || window.innerWidth <= 767) {
      return "bottom-start";
    }

    const spaceRight = window.innerWidth - rect.right;
    const spaceLeft = rect.left;

    if (spaceRight >= CALENDAR_WIDTH_ESTIMATE) return "right-start";
    if (spaceLeft >= CALENDAR_WIDTH_ESTIMATE) return "left-start";
    return spaceRight >= spaceLeft ? "right-start" : "left-start";
  };

  checkCheckoutDateFromPlacement = () => {
    this.setState({
      checkoutDateFromPlacement: this.getResponsivePlacement(
        this.checkoutDateFromInputGroupRef,
      ),
    });
  };

  checkCheckoutDateToPlacement = () => {
    this.setState({
      checkoutDateToPlacement: this.getResponsivePlacement(
        this.checkoutDateToInputGroupRef,
      ),
    });
  };

  changeHandler = async (event) => {
    let input = this.state.input;
    let value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    input[event.target.name] = value;
    await this.setState({ [event.target.name]: value, input: input });
    // Validate
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  async filterData() {
    const fromError = !this.state.checkout_date_from
      ? "Check Out From Date is required."
      : "";
    const toError = !this.state.checkout_date_to
      ? "Check Out To Date is required."
      : "";
    if (fromError || toError) {
      this.setState({ checkoutFromError: fromError, checkoutToError: toError });
      return;
    }
    this.setState({ checkoutFromError: "", checkoutToError: "" });
    let checkOutFromDate = this.state.checkout_date_from
      ? Moment(this.state.checkout_date_from).format("YYYY-MM-DD")
      : "";
    let checkOutDateTo = this.state.checkout_date_to
      ? Moment(this.state.checkout_date_to).format("YYYY-MM-DD")
      : "";
    let unit_search = this.state.unit_slug
      ? this.state.unit_slug.map((slug) => `${slug}`).join(",")
      : "";
    let queryString =
      "checkout_date_from=" +
      checkOutFromDate +
      "&unit_slug=" +
      unit_search +
      "&channel_slug=" +
      (this.state.set_channel ? this.state.set_channel : "") +
      "&checkout_date_to=" +
      checkOutDateTo +
      "&is_search=1";
    let moduleSearchString = "";
    let searchDisplay = "";
    moduleSearchString = this.state.checkout_date_from
      ? "Check Out From Date- " + this.state.checkout_date_from
      : "";
    moduleSearchString = this.state.unit_slug
      ? moduleSearchString
        ? moduleSearchString + " ," + " Unit - " + this.state.unit_slug
        : " Unit - " + this.state.unit_slug
      : moduleSearchString;
    moduleSearchString = this.state.set_channel
      ? moduleSearchString
        ? moduleSearchString +
          " ," +
          " Channel - " +
          this.state.selectedChannelList.label
        : " Channel - " + this.state.selectedChannelList.label
      : moduleSearchString;
    searchDisplay =
      "Check Out From Date- " +
      Moment(checkOutFromDate).format("MM/DD/YY") +
      ", " +
      "Check Out To Date- " +
      Moment(checkOutDateTo).format("MM/DD/YY");
    if (this.state.unit_lable) {
      searchDisplay = searchDisplay + ", Unit- " + this.state.unit_lable;
    }
    if (this.state.set_channel) {
      searchDisplay =
        searchDisplay + ", Channel- " + this.state.selectedChannelList.label;
    }
    if (
      this.state.checkout_date_from ||
      this.state.unit_slug ||
      this.state.checkout_date_to ||
      this.state.set_channel
    ) {
      this.setState({ customQueryString: queryString });
      this.searchToggle();
      this.setState({ is_search: 1 });
      this.setState({ module_search: moduleSearchString });
      this.setState({ module_search_display: searchDisplay.split(",") });
      saveReportFilter({
        checkout_date_from: this.state.checkout_date_from,
        checkout_date_to: this.state.checkout_date_to,
        unit_slug: this.state.unit_slug || [],
        unit_lable: this.state.unit_lable || [],
        selectedUnitList: this.state.selectedUnitList || [],
        set_channel: this.state.set_channel || "",
        selectedChannelList: this.state.selectedChannelList || [],
        is_search: 1,
        customQueryString: queryString,
        module_search: moduleSearchString,
        module_search_display: searchDisplay.split(","),
      });
      await this.removeTotalClass();
      this.getPayOutReports(queryString);
    }
  }

  /* table events */
  tableChangeHandler = (data) => {
    let queryString = Object.keys(data)
      .map((key) => {
        if (key === "sort_order" && data[key]) {
          return (
            encodeURIComponent("sort_order") +
            "=" +
            encodeURIComponent(data[key].order) +
            "&" +
            encodeURIComponent("sort_column") +
            "=" +
            encodeURIComponent(data[key].column)
          );
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "page_size") {
            newKey = "per_page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          return (
            encodeURIComponent(newKey) + "=" + encodeURIComponent(data[key])
          );
        }
      })
      .join("&");

    if (data.filter_value !== "") {
      this.setState({ tableQueryString: queryString });
    } else {
      queryString += "&" + this.state.customQueryString;
      this.setState({ tableQueryString: queryString });
    }

    if (data.filter_value !== this.state.filter_value) {
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getPayOutReports(queryString),
          global.filter_time,
        ),
        filter_value: data.filter_value,
      });
    } else {
      this.getPayOutReports(queryString);
    }
  };

  rowClickedHandlerPay = (event, data, rowIndex) => {
    if (data.unit_slug) {
      this.showPayoutReport(data.unit_slug);
    }
  };

  rowClickedHandler = (event, data, rowIndex) => {
    if (data.reservation_slug) {
      let route =
        this.props.match.params.propertySlug !== undefined
          ? "reservations/view/" + data.reservation_slug
          : this.state.property_slug
            ? "/reservations/view/" +
              this.state.property_slug +
              "/" +
              data.reservation_slug
            : "/reservations/view/" +
              data.property_slug +
              "/" +
              data.reservation_slug;
      window.open(route, "_blank");
    }
  };

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
              ? "black"
              : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "black"
            : state.isFocused && "black",
      }),
    };
    return (
      <>
        <main>
          <Container className="innter-container">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                {this.props.match.params.propertySlug !== undefined ? (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <ReportSidebar property_slug={this.state.property_slug} />
                    </div>
                  </div>
                ) : (
                  <div className="col-md-2 left">
                    <div className="child-menu-section">
                      <AllPropertyReportSidebar
                        property_slug={this.state.property_slug}
                      />
                    </div>
                  </div>
                )}
                <div
                  className={
                    this.props.match.params.propertySlug !== undefined
                      ? "col-md-10 right"
                      : "col-md-12"
                  }
                >
                  <div className="col-md-12 mg-t-10 mg-b-10 pd-t-10 pd-b-10"></div>
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-l-15 pd-r-0">
                    <div className="dashbaord-pageHeadertitle d-flex justify-content-between align-items-center flex-wrap mg-b-0">
                      <h3>Property Payout by Unit and Reservation</h3>
                      <div className="d-flex justify-content-end pd-l-0 pd-r-0 mg-b-0">
                        <button
                          className="btn-success-outline-small mr-3"
                          onClick={this.searchToggle}
                        >
                          Search
                        </button>
                        {global.userPermissions.checkPermission(
                          "resident-payout-report-export",
                        ) ? (
                          <button
                            className="btn-success-outline-small mr-0"
                            onClick={this.exportToggle}
                          >
                            Export
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  {this.props.match.params.propertySlug === undefined ? (
                    <>
                      <div className="row pd-lg-l-15 pd-xs-l-15">
                        <div className="col-xxl-2 col-sm-3 pd-lg-r-0 pd-xs-r-15 pd-lg-l-45 pd-xs-l-15">
                          <div className="col-sm-12 mg-t-5 mg-md-t-0 pd-l-0 pd-lg-r-30 pd-xs-r-0 mg-b-20">
                            <label className="form-label text-left pd-b-2 mb-0">
                              Property
                            </label>
                            <Select
                              isMulti
                              styles={{
                                option: (provided, state) => ({
                                  ...provided,
                                  color:
                                    state.isSelected && state.isFocused
                                      ? "white"
                                      : state.isSelected
                                        ? "black"
                                        : state.isFocused && "white",
                                  backgroundColor:
                                    state.isSelected && state.isFocused
                                      ? "black"
                                      : state.isFocused && "black",
                                }),
                              }}
                              className="multiselect property_select"
                              menuPlacement="bottom"
                              placeholder="All Properties"
                              value={this.state.selectedPropertyList}
                              options={this.state.newPropertyList}
                              onChange={(value) =>
                                this.handleChangePropertyList(value)
                              }
                              defaultValue={this.state.selectedPropertyList}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 2,
                                colors: {
                                  ...theme.colors,
                                  primary: "#fff",
                                  primary75: "#000",
                                  primary50: "#000",
                                  primary25: "#000",
                                },
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-10 col-md-9 col-sm-8 pd-r-15 pd-l-15">
                          {this.state.is_search === 1 ? (
                            <div className="col-xxl-12 col-sm-12 pd-r-0 pd-lg-r-30 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                              <div className="custm-filter">
                                <div>
                                  {" "}
                                  <label className="form-label text-left pd-b-2 mb-0">
                                    Search Applied On
                                  </label>
                                </div>
                                <div className="filter_bg_cust">
                                  {this.state.module_search_display.map(
                                    (item, i) => {
                                      return <span key={i}>{item}</span>;
                                    },
                                  )}
                                  <button
                                    onClick={this.clearFilter}
                                    className="btn-fliter-clear"
                                  >
                                    Clear
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div className="col-xxl-12 col-sm-12 pd-r-0 pd-lg-r-30 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                              <div className="custm-filter">
                                <div>
                                  {" "}
                                  <label className="form-label text-left pd-b-2 mb-0">
                                    Search Applied On
                                  </label>
                                </div>
                                <div className="filter_bg_cust">
                                  <span>
                                    {`Check Out From Date -  ${Moment(
                                      this.state.checkout_date_from,
                                    ).format("MM/DD/YY")} `}
                                  </span>
                                  <span>
                                    {` Check Out To Date - ${Moment(
                                      this.state.checkout_date_to,
                                    ).format("MM/DD/YY")}
                          `}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="col-xxl-12 pd-r-15 pd-l-15">
                      {this.state.is_search === 1 ? (
                        <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                          <div className="custm-filter">
                            <div>
                              {" "}
                              <label className="form-label text-left pd-b-2 mb-0">
                                Search Applied On
                              </label>
                            </div>
                            <div className="filter_bg_cust">
                              {this.state.module_search_display.map(
                                (item, i) => {
                                  return <span key={i}>{item}</span>;
                                },
                              )}
                              <button
                                onClick={this.clearFilter}
                                className="btn-fliter-clear"
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        // <div className="col-md-12 pd-lg-l-45 pd-md-l-45  pd-lg-r-45 pd-md-r-30   mg-t-0 d-inline-flex align-items-center justify-content-between">
                        //   {`Search applied on: Check Out From Date -  ${Moment(
                        //     this.state.checkout_date_from
                        //   ).format("MM/DD/YY")} , Check Out To Date - ${Moment(
                        //     this.state.checkout_date_to
                        //   ).format("MM/DD/YY")}`}
                        // </div>
                        <div className="col-xxl-12 col-sm-12 pd-xs-l-30 d-inline-flex align-items-start justify-content-end justify_mob_filter scrolling-carousel">
                          <div className="custm-filter">
                            <div>
                              {" "}
                              <label className="form-label text-left pd-b-2 mb-0">
                                Search Applied On
                              </label>
                            </div>
                            <div className="filter_bg_cust">
                              <span>
                                {`Check Out From Date -  ${Moment(
                                  this.state.checkout_date_from,
                                ).format("MM/DD/YY")} `}
                              </span>
                              <span>
                                {` Check Out To Date - ${Moment(
                                  this.state.checkout_date_to,
                                ).format("MM/DD/YY")}
                          `}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 pd-lg-l-0 pd-lg-r-15 pd-xs-r-0">
                    <div className="scrolling-carousel pd-l-15 scroll-slide">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="all"
                        onSelect={(e) => this.getActiveClass(e)}
                        eventKey={this.state.activeClass}
                        className="pd-r-60"
                      >
                        <Tab.Content className="m-0">
                          <div className="dashboardRightcard background-none pt-0 pd-l-30 pd-r-30">
                            <div className="mg-t-18 brandList pd-l-15 pd-r-15 payout-report-tbl- resident-payout-table earning-report-tbl payout-details-tbl">
                              <div className=" pd-lg-l-0 pd-xs-l-0">
                                <div className="scroll-report-table">
                                  <ReactDatatable
                                    className="table no-wrap mg-b-30 pd-b-2 brandtable border table_last_row"
                                    config={
                                      this.state.total_record > global.page_size
                                        ? this.state.config
                                        : this.state.config
                                    }
                                    records={this.state.records}
                                    columns={this.state.columns}
                                    extraButtons={this.state.extraButtons}
                                    dynamic={true}
                                    total_record={this.state.total_record}
                                    onChange={this.tableChangeHandler}
                                    onRowClicked={this.rowClickedHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </main>

        {/* Module search popup modal */}
        <Modal
          show={this.state.isSearch}
          className="modal-large searchModalbox"
          centered
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.searchToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">
              Search in Property Payout by Unit and Reservation
            </h3>
            <div className="row col-12 m-0 pd-lg-l-15 pd-lg-r-15 pd-xs-l-0 pd-xs-r-0">
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup
                  className="mt-3"
                  ref={this.checkoutDateFromInputGroupRef}
                >
                  <label>Check Out From Date</label>
                  <DatePicker
                    className="form-control max_width_100"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    disabledKeyboardNavigation
                    strictParsing
                    autoComplete="off"
                    yearDropdownItemNumber={global.yearDropdownItemNumber}
                    name="checkout_date_from"
                    selected={this.state.checkout_date_from}
                    dateFormat="MM/dd/yy"
                    onChange={(data) =>
                      this.changeHandler({
                        target: {
                          type: "date",
                          name: "checkout_date_from",
                          value: data,
                        },
                      })
                    }
                    popperPlacement={this.state.checkoutDateFromPlacement}
                    onCalendarOpen={this.checkCheckoutDateFromPlacement}
                    popperModifiers={{
                      preventOverflow: {
                        enabled: true,
                        escapeWithReference: false,
                      },
                    }}
                  />
                  {this.state.checkoutFromError && (
                    <span className="field-validation-error">
                      {this.state.checkoutFromError}
                    </span>
                  )}
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Unit</label>
                  <div className="col-md-12 p-0">
                    <Select
                      isMulti
                      styles={customStyles}
                      isClearable={true}
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      menuPlacement="auto"
                      value={this.state.selectedUnitList}
                      options={this.state.newUnitList}
                      onChange={(value) => this.handleChangeUnitList(value)}
                      defaultValue={this.state.selectedUnitList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 pd-lg-l-15 pd-lg-r-15 pd-sm-l-15 pd-sm-r-15 pd-xs-l-0 pd-xs-r-0">
                <InputGroup
                  className="mt-3"
                  ref={this.checkoutDateToInputGroupRef}
                >
                  <label>Check Out To Date</label>
                  <div className="col-md-12 p-0">
                    <DatePicker
                      className="form-control max_width_100"
                      showMonthDropdown
                      showYearDropdown
                      scrollableYearDropdown
                      disabledKeyboardNavigation
                      strictParsing
                      autoComplete="off"
                      yearDropdownItemNumber={global.yearDropdownItemNumber}
                      name="checkout_date_to"
                      selected={this.state.checkout_date_to}
                      dateFormat="MM/dd/yy"
                      onChange={(data) =>
                        this.changeHandler({
                          target: {
                            type: "date",
                            name: "checkout_date_to",
                            value: data,
                          },
                        })
                      }
                      popperPlacement={this.state.checkoutDateToPlacement}
                      onCalendarOpen={this.checkCheckoutDateToPlacement}
                      popperModifiers={{
                        preventOverflow: {
                          enabled: true,
                          escapeWithReference: false,
                        },
                      }}
                    />
                  </div>
                  {this.state.checkoutToError && (
                    <span className="field-validation-error">
                      {this.state.checkoutToError}
                    </span>
                  )}
                </InputGroup>
                <InputGroup className="mt-3">
                  <label>Channel</label>
                  <div className="col-md-12 p-0">
                    <Select
                      styles={customStyles}
                      isClearable={true}
                      menuPlacement="auto"
                      className="multiselect"
                      classNamePrefix={"my-custom-react-select"}
                      options={this.state.newChannelList}
                      getOptionValue={(option) => `${option.label}`}
                      onChange={(value) => this.handleChangeChannel(value)}
                      value={this.state.selectedChannelList}
                      defaultValue={this.state.selectedChannelList}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 2,
                        colors: {
                          ...theme.colors,
                          primary: "#fff",
                          primary75: "#000",
                          primary50: "#000",
                          primary25: "#000",
                        },
                      })}
                    />
                  </div>
                </InputGroup>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.searchToggle()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="m-0 btn btn btn-success btn-block"
                onClick={() => this.filterData()}
                disabled={this.state.isSubmit ? true : false}
              >
                {this.state.isSubmit ? global.loader : "Search"}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        {/* Module Export  popup modal */}
        <Modal show={this.state.isModel} className="modal-xs" centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.exportToggle()}>
              {global.closee}
            </span>
            <h3 className="text-center">Export</h3>
            <div className="row col-12 m-0">
              <div className="col-lg-12 col-md-12 col-sm-12 p-0">
                <InputGroup className="mt-0">
                  <label>Select Export File Type : </label>
                  <div className="row">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-6 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="xlsx"
                        checked={this.state.alertType === "xlsx" ? true : false}
                        type={"radio"}
                        id="xlsx"
                        label={"XLSX"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-6 mg-t-5 mg-md-t-0 pd-lg-l-30 pd-lg-r-30 pd-xs-l-15 pd-xs-r-15 mg-b-15">
                      <Form.Check
                        onChange={(e) => this.changeExport(e)}
                        name="alert_type"
                        value="csv"
                        checked={this.state.alertType === "csv" ? true : false}
                        type={"radio"}
                        id="csv"
                        label={"CSV"}
                        className={"rdiobox mg-r-20"}
                      />
                    </div>
                  </div>
                </InputGroup>

                {this.state.exportMesssage !== "" && (
                  <div>
                    {this.state.exportMesssage}
                    <br></br>
                    <br></br>
                    {/* {this.state.exportFilePath !== undefined && (
                      <a href={this.state.exportFilePath}> Download File </a>
                    )} */}
                  </div>
                )}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="mx-auto- mg-r-30 btn btn btn-success btn-block"
                    onClick={() => this.ExportData()}
                    disabled={this.state.isSubmit ? true : false}
                  >
                    {this.state.isSubmit ? global.loader : "Export"}
                  </button>
                  <button
                    type="button"
                    className="mx-auto- m-0  btn btn-outline-light btn-block"
                    onClick={() => this.exportToggle()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        {/* Module Pay Out Report Data */}
        <Modal
          show={this.state.is_pay_out_modal}
          className="modal-large searchModalbox"
          centered
          size="lg"
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              this.filterData();
            }
          }}
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.payoutDataModalToggle()}
            >
              {global.closee}
            </span>
            <h3 className="text-center mb-0">
              {this.state.payoutDetailsTitle} Payout Detail
            </h3>
            <div className="row col-12 m-auto pd-lg-l-15 pd-lg-r-0 pd-xs-l-0 pd-xs-r-0">
              <div className="payout-report-tbl payout-details-tbl">
                <ReactDatatable
                  className="table no-wrap mg-b-30 pd-b-2 brandtable border table_last_row"
                  config={
                    this.state.total_record_pay > global.page_size
                      ? this.state.configPay
                      : this.state.configPay
                  }
                  records={this.state.record_pay}
                  columns={this.state.columns_pay}
                  extraButtons={this.state.extraButtons}
                  dynamic={true}
                  total_record={this.state.total_record_pay}
                  onChange={this.tableChangeHandler}
                  onRowClicked={this.rowClickedHandlerPay}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
export default PayoutsReports;
